'use client';

import React, { createContext, type ReactNode, useContext } from 'react';

import { AppConfig } from '@/models/app-config';

const EnvContext = createContext<Record<string, string>>({});

interface EvnProviderProps {
  children: ReactNode;
  env: AppConfig;
}

export const EnvProvider = ({ children, env }: EvnProviderProps) => (
  <EnvContext.Provider value={env}>{children}</EnvContext.Provider>
);

export const useEnvContext = () => useContext(EnvContext);
